<template>
  <div class="relative mx-auto max-w-7xl overflow-hidden bg-white">
    <div class="mx-auto max-w-7xl">
      <div class="relative z-10 bg-white pb-8 lg:w-1/2">
        <svg
          class="absolute right-0 hidden h-full w-48 translate-x-24 transform text-white lg:block"
          fill="white"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <polygon points="50,0 100,0 50,100 0,100" />
        </svg>

        <div class="relative px-4 pt-6 sm:px-6 lg:px-8" />

        <main
          class="mx-auto mt-10 max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28"
        >
          <div class="sm:text-center lg:text-left">
            <h1
              class="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl md:text-6xl"
            >
              <span class="block text-blue-ribbon-500 xl:inline"> No </span
              >set-up fee,<br />
              <span class="block text-blue-ribbon-500 xl:inline"> no </span
              >front costs,<br />
              <span class="block text-blue-ribbon-500 xl:inline"> no </span
              >subscription!
            </h1>
            <p
              class="mt-3 text-base text-gray-500 sm:mx-auto sm:mt-5 sm:max-w-xl sm:text-lg md:mt-5 md:text-xl lg:mx-0"
            >
              Sign your garage now to start receiving bookings!
            </p>
            <div
              class="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start"
            >
              <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                <div
                  class="z-20 flex flex-col overflow-hidden rounded border border-gray-100 shadow-lg"
                >
                  <div class="grow px-6 py-4">
                    <div class="mb-2 text-xl font-bold text-blue-ribbon-500">
                      Sign up
                    </div>
                    <p class="text-base text-gray-500">
                      Right now, we're looking for quality garages from all
                      around the UK to join our network.
                      <strong
                        >It's completely free and can be done now, in just 5
                        minutes.</strong
                      >
                    </p>
                  </div>
                  <div class="px-8 pt-2 pb-8">
                    <a
                      rel="noopener"
                      target="_blank"
                      label="GaragesNear.me dashboard"
                      aria-label="GaragesNear.me dashboard"
                      href="https://dash.garagesnear.me/"
                      class="flex items-center justify-center whitespace-nowrap rounded-md border border-transparent bg-rio-grande-500 px-8 py-3 text-base font-medium text-white hover:bg-rio-grande-600"
                    >
                      Sign up
                    </a>
                  </div>
                </div>
                <div
                  class="z-20 flex flex-col overflow-hidden rounded border border-gray-100 shadow-lg"
                >
                  <div class="grow px-6 py-4">
                    <div class="mb-2 text-xl font-bold text-blue-ribbon-500">
                      Welcome back
                    </div>
                    <p class="text-base text-gray-500">
                      Please sign in to GaragesNear.me to continue to the
                      dashboard.
                    </p>
                  </div>
                  <div class="px-8 pt-2 pb-8">
                    <a
                      rel="noopener"
                      target="_blank"
                      label="GaragesNear.me dashboard"
                      aria-label="GaragesNear.me dashboard"
                      href="https://dash.garagesnear.me/"
                      class="flex items-center justify-center whitespace-nowrap rounded-md border border-transparent bg-blue-ribbon-500 px-8 py-3 text-base font-medium text-white hover:bg-blue-ribbon-600"
                    >
                      Sign in
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
    <div class="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
      <div
        class="absolute h-56 w-full bg-gradient-to-t from-black to-transparent opacity-50 sm:h-72 md:h-96 lg:h-full lg:w-full"
      />
      <img
        class="block h-56 w-full object-cover object-center sm:h-72 md:h-96 lg:hidden lg:h-full"
        src="@/assets/for-garages.webp"
        alt="A mechanic and a customer shaking hands inside a garage."
      />
      <img
        class="hidden h-56 w-full object-cover object-center sm:h-72 md:h-96 lg:block lg:h-full"
        src="@/assets/for-garages-cropped.webp"
        alt="A mechanic and a customer shaking hands inside a garage."
      />
    </div>
  </div>

  <div class="bg-blue-ribbon-500 py-10 text-white">
    <h3
      class="text-center text-2xl font-extrabold tracking-tight sm:text-3xl md:text-4xl"
    >
      <span class="block xl:inline">
        Discover the benefits of joining your garage
      </span>
    </h3>
    <div class="py-12">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="grid grid-cols-2 gap-4 lg:grid-cols-4">
          <!-- <div class="text-gray-900 text-4xl">
            Find your local garage in
            <span class="font-semibold">3 simple steps.</span>
          </div> -->
          <div class="rounded bg-white p-4 text-center text-gray-500 shadow-lg">
            <span class="mb-2 flex items-end justify-center">
              <DesktopComputerIcon class="h-16 w-auto text-blue-ribbon-500" />
              <DeviceMobileIcon class="h-12 w-auto text-blue-ribbon-500" />
            </span>
            <div class="text-xl font-semibold text-blue-ribbon-500">
              Modern booking platform
            </div>
            <p class="mt-2 text-base">
              You don't need any special equipment to use GaragesNear.me. You
              can access the booking system on desktop, phone or tablet.
            </p>
          </div>
          <div class="rounded bg-white p-4 text-center text-gray-500 shadow-lg">
            <span class="mb-2 flex items-end justify-center">
              <EmojiHappyIcon class="h-16 w-auto text-blue-ribbon-500" />
            </span>
            <div class="text-xl font-semibold text-blue-ribbon-500">
              Customer experience
            </div>
            <p class="mt-2 text-base">
              We connect car owners directly to you with our data-driven quotes.
              Our quick and simple booking system is easy for you and can owners
              to use.
            </p>
          </div>
          <div class="rounded bg-white p-4 text-center text-gray-500 shadow-lg">
            <span class="mb-2 flex items-end justify-center">
              <CurrencyPoundIcon class="h-16 w-auto text-blue-ribbon-500" />
            </span>
            <div class="text-xl font-semibold text-blue-ribbon-500">
              Additional sales
            </div>
            <p class="mt-2 text-base">
              Increase your visibility! Signing up to GaragesNear.me gives you
              access to new customers.
            </p>
          </div>
          <div class="rounded bg-white p-4 text-center text-gray-500 shadow-lg">
            <span class="mb-2 flex items-end justify-center">
              <TrendingUpIcon class="h-16 w-auto text-blue-ribbon-500" />
            </span>
            <div class="text-xl font-semibold text-blue-ribbon-500">
              Collaborate and grow
            </div>
            <p class="mt-2 text-base">
              GaragesNear.me offers garages a unique booking platform, less
              paperwork and less hassle!
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mx-auto mt-10 mb-10 max-w-7xl px-4 sm:px-6 lg:px-8">
    <div class="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2">
      <img
        src="@/assets/for-garages-2.webp"
        alt="A laptop and a mobile phone with the garage application open."
      />
      <div>
        <h1
          class="text-xl font-extrabold tracking-tight text-gray-900 sm:text-2xl md:text-3xl"
        >
          <span class="text-blue-ribbon-500">Increase visibility</span>
        </h1>
        <div class="text-medium mt-3 font-semibold text-gray-900">
          Garages who partner with GaragesNear.me get online visibility and an
          automatic pricing and booking system so receiving work from us is
          stress-free for everyone.
        </div>
        <div class="mt-3 text-gray-500">
          <p class="">
            Uniquely, our sophisticated pricing engine joins data for vehicle
            details, repair times and parts prices and then blends it with your
            information on labour rates, parts discounts and workshop
            availability. The result is automatic accurate instant quotations
            and easy bookings.
          </p>
          <p class="mt-4">
            There are no subscription or licence fees to join GaragesNear.me,
            instead we simply collect 10% of the proceeds on a per-booking basis
            after you've completed the work.
          </p>
        </div>
      </div>
    </div>
    <div class="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2">
      <div>
        <h1
          class="text-xl font-extrabold tracking-tight text-gray-900 sm:text-2xl md:text-3xl"
        >
          <span class="text-blue-ribbon-500">Local, reliable, fast</span>
        </h1>
        <div class="mt-3 text-gray-500">
          <p class="">
            Our aim is to improve motorists' online experience by enabling
            accurate quotations from quality garages. We do not dictate your
            prices or demand costly extra services like "collection and
            delivery" and we don't hide your identity from visitors to our
            website. We seek to build sustainable business relationships with
            our garage partners so we can jointly open up opportunities with
            individuals and business users looking for quality, convenience and
            accuracy when booking car maintenance online.
          </p>
        </div>
        <div class="text-medium mt-3 font-semibold text-gray-900">
          No special equipment is needed, any computer or tablet with internet
          access is all you need. Our garage dashboard is designed for intuitive
          use.
        </div>
      </div>
      <!-- <img
        src="@/assets/for-garages-3.webp"
        alt="A mechanic working on a car."
      /> -->
      <img
        src="@/assets/how-it-works.webp"
        alt="A mechanic working on a car."
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@vueuse/head'

import {
  DesktopComputerIcon,
  DeviceMobileIcon,
  EmojiHappyIcon,
  CurrencyPoundIcon,
  TrendingUpIcon
} from '@heroicons/vue/outline'

useHead({
  title: 'For garages - GaragesNear.me',
  meta: [
    {
      name: 'og:title',
      content: 'For garages - GaragesNear.me'
    },
    {
      name: 'og:image',
      content: '/open-graph/hero.webp'
    },
    {
      name: 'og:image:alt',
      content: 'GaragesNear.me banner'
    },
    {
      name: 'og:image:width',
      content: 1280
    },
    {
      name: 'og:image:height',
      content: 576
    }
  ]
})
</script>
